import React, {Component, PropTypes} from 'react';

// Subviews
import Row from './row';

export default class SIMSvgSeatBlock extends Component {

  shouldComponentUpdate (nextProps) {
    var changed = {
      availableSeatCount: this.props.availableSeatCount !== nextProps.availableSeatCount,
      section:            this.props.activeSection !== nextProps.activeSection,
      seats:              this.props.activeSeats !== nextProps.activeSeats
    };
    return changed.availableSeatCount || changed.section || changed.seats;
  }

  render () {
    const {translate, angle, position, rows, activeSeats} = this.props;

    var attributes = {
      'data-component': 'svg__block',
      className:        'section',
      transform:        ''
    };

    if (translate.x || translate.y) {
      attributes.transform += 'translate(' + translate.x + ',' + translate.y + ') ';
    }

    if (angle) {
      attributes.transform += 'rotate(' + (angle * -1) + ',' + position.x + ',' + position.y + ')';
    }

    return (
      <g {...attributes}>
        {rows.map((row, idx) => <Row {...row} key={row.section + '_' + idx} activeSeats={activeSeats}/>)}
      </g>
    );
  }
}

SIMSvgSeatBlock.propTypes = {
  translate:   PropTypes.object.isRequired,
  position:    PropTypes.object.isRequired,
  angle:       PropTypes.number.isRequired,
  rows:        PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSeats: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/svg/seatBlock.jsx